import React from 'react';
import propTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add'
import format from 'string-format';
import {Fab} from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {getSpecNum, getSpecRastitelno, getSpecRastitelnoList} from "../../../redux/specRastitelno/reducer";
import {bindActionCreators} from "redux";
import {
    deleteSpecRastitelnoRequest,
    duplicateSpecRastitelnoRequest,
    fetchSpecRastitelnoList
} from "../../../redux/specRastitelno/fetch";
import {connect} from "react-redux";
import PageBase from "../../PageBase";
import Notification from "../../../common/Notification";
import ConfirmDelete from "../../../common/ConfirmDelete";
import globalStyles from "../../styles";


const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 18
    },
    body: {
        fontSize: 16,
    },

}))(TableCell);

const CustomTableSmallCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 18,
        width: 20
    },
    body: {
        fontSize: 16,
        width: 20
    },

}))(TableCell);

const styles = theme => ({
    row: {
        '&:nth-of-Status(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    button: {
        margin: theme.spacing.unit,
    }
});


export class SpecRastitelnoList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            deleteRecord: false,
            id: '',
            pgNo: 1,
            pageSize: 10,
            notify: false,
            message: '',
            error: false
        }
        this.deleteSpecRastitelno = this.deleteSpecRastitelno.bind(this);
        this.deleteAfterConfirmation = this.deleteAfterConfirmation.bind(this);
        this.editSpecRastitelno = this.editSpecRastitelno.bind(this);
        this.addSpecRastitelno = this.addSpecRastitelno.bind(this);
        this.sortTable = this.sortTable.bind(this);
        this.addLeadingZeroes = this.addLeadingZeroes.bind(this);
        this.formatDate = this.formatDate.bind(this);

    }

    formatDate(inputDateTime) {
        const date = new Date(inputDateTime);
        // Use 'en-GB' locale for "dd.mm.yyyy" format
        return date.toLocaleDateString('en-GB');
    }

    sortTable = (column) => {
        const { specRastitelnoList, sortDirection } = this.state;

        // Determine the sort direction
        const direction = sortDirection === 'desc' ? -1 : 1;

        // Sort the array based on the selected column
        const sortedList = specRastitelnoList.sort((a, b) => {
            if (column === 'createdAt') {
                // Sort by date for the 'createdAt' column
                const dateA = new Date(a[column].split('.').reverse().join('-'));
                const dateB = new Date(b[column].split('.').reverse().join('-'));

                if (dateA < dateB) return -direction;
                if (dateA > dateB) return direction;
            } else {
                // Sort alphabetically for other columns
                if (a[column] < b[column]) return -direction;
                if (a[column] > b[column]) return direction;
            }

            return 0;
        });

        this.setState({
            specRastitelnoList: sortedList,
            sortBy: column,
            sortDirection: sortDirection === 'asc' ? 'desc' : 'asc',
        });
    };


    componentWillMount() {
        const {fetchSpecRastitelnoList} = this.props;
        fetchSpecRastitelnoList();
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.specNum !== nextProps.specNum || this.state.specRastitelnoList !== nextProps.specRastitelnoList) {
            this.setState({ specRastitelnoList: nextProps.specRastitelnoList }, () => {
                this.sortTable('broj_spec');
            });
        }
    }

    deleteSpecRastitelno(id) {
        this.setState({deleteRecord: true, id: id});
    }

    editSpecRastitelno(id) {
        this.props.history.push(`/SpecRastitelno/` + id);
    }

    duplicateSpecRastitelno(id) {
        this.props.duplicateSpecRastitelnoRequest(id)
        this.showNotification("Успешно креиран дупликат");
        setTimeout(() => this.redirectToSpecRastitelnoList(), 1000);
    }

    redirectToSpecRastitelnoList() {
        window.location.reload()
    }

    deleteAfterConfirmation(deleteConfirmed) {
        this.setState({deleteRecord: false});
        if (deleteConfirmed) {
            /* let selectedid =  this.state.id
              Create and call deleteSpecRastitelno action */
            const {deleteSpecRastitelnoRequest} = this.props
            deleteSpecRastitelnoRequest(this.state.id)
            this.showNotification("Успешно избришано");
        }
        this.setState({id: ''});
    }

    showNotification = (msg, err) => {
        if (err)
            this.setState({notify: true, message: msg, error: true});
        else
            this.setState({notify: true, message: msg, error: false});
    };

    handleNotificationClosed = () => {
        this.setState({
            notify: false
        });
    };

    addSpecRastitelno() {
        this.props.history.push(`/CreateSpecRastitelno`);
    }

    addLeadingZeroes(num) {
        const number = num ? num : 0
        const numberString = number.toString()
        const desiredLength = 4;

        if (numberString.length >= desiredLength) {
            // If the number already has 4 or more digits, return it as is
            return numberString;
        } else {
            // Add leading zeroes to make it a 4-digit number
            const numberOfZeroesToAdd = desiredLength - numberString.length;
            const leadingZeroes = '0'.repeat(numberOfZeroesToAdd);
            return leadingZeroes + numberString;
        }
    }

    render() {
        const {classes, specRastitelnoList} = this.props;
        const {notify, message, error} = this.state;
        return (
            <PageBase title="Листа спецификации растително">
                <Fab
                    variant="extended"
                    color="primary"
                    aria-label="add" className={classes.button}
                    onClick={this.addSpecRastitelno}
                >
                    <AddIcon/>
                    Додади спецификација
                </Fab>
                <Table>
                    <TableHead>
                        {specRastitelnoList &&
                        <TableRow>
                            <CustomTableCell onClick={() => this.sortTable('broj_spec')}>
                                Број на сертификат
                            </CustomTableCell>
                            <CustomTableCell onClick={() => this.sortTable('createdAt')}>
                                Датум на креирање
                            </CustomTableCell>
                            <CustomTableCell onClick={() => this.sortTable('pouName')}>
                                ПОУ
                            </CustomTableCell>
                            <CustomTableCell>Дупликат</CustomTableCell>
                            <CustomTableSmallCell>Измени</CustomTableSmallCell>
                            <CustomTableSmallCell>Избриши</CustomTableSmallCell>
                        </TableRow>
                        }
                    </TableHead>
                    <TableBody>
                        {specRastitelnoList && specRastitelnoList.map(SpecRastitelno => {
                            return (
                                <TableRow key={SpecRastitelno.Broj} className={classes.row}>
                                    <CustomTableCell>{this.addLeadingZeroes(SpecRastitelno.broj_spec)}</CustomTableCell>
                                    <CustomTableCell>{this.formatDate(SpecRastitelno.createdAt)}</CustomTableCell>
                                    <CustomTableCell>{SpecRastitelno.pouName}</CustomTableCell>
                                    <CustomTableCell>
                                        <Button style={globalStyles.deleteButton} variant="contained" size={"small"}
                                                aria-label="duplicate"
                                                onClick={() => this.duplicateSpecRastitelno(SpecRastitelno.id)}>
                                            <FileCopyIcon/>
                                        </Button>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Button style={globalStyles.deleteButton} variant="contained" size={"small"}
                                                aria-label="edit"
                                                onClick={() => this.editSpecRastitelno(SpecRastitelno.id)}>
                                            <EditIcon/>
                                        </Button>
                                    </CustomTableCell>
                                    <CustomTableCell>
                                        <Button style={globalStyles.deleteButton} variant="contained" size={"small"}
                                                aria-label="delete"
                                                onClick={() => this.deleteSpecRastitelno(SpecRastitelno.id)}>
                                            <DeleteIcon/>
                                        </Button>
                                    </CustomTableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                <ConfirmDelete resourceHeader="Избриши спецификација?"
                               resourceOpis={format("Дали сте сигурни дека сакате да ја ибришете спецификацијата'{}'?", this.state.id)}
                               onModalClose={this.deleteAfterConfirmation}
                               openDeleteDialog={this.state.deleteRecord}/>

                <Notification
                    notify={notify}
                    message={message}
                    error={error}
                    closed={this.handleNotificationClosed}
                />
            </PageBase>
        );
    }
}

SpecRastitelnoList.propTypes = {
    classes: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
    specRastitelnoList: getSpecRastitelnoList(state),
    specRastitelno: getSpecRastitelno(state),
    specNum: getSpecNum(state)
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSpecRastitelnoList,
        deleteSpecRastitelnoRequest,
        duplicateSpecRastitelnoRequest
    }, dispatch)
}

export default withStyles(styles)(
    connect(mapStateToProps, mapDispatchToProps)(SpecRastitelnoList))